/**
 * This is the denomidator of the current app version.
 * This constant has a direct impact on whether or not service worker updates will be read by the browser
 *
 * !!! Remember to always update this when a new version is built
 */
export const version = '1.1.580';
